
import axios from 'config/axiosConfig'
import setFilters from 'config/filters'
import { go } from 'keys/apis'
import { getAssessmentFilters, getTestTakerFilters } from 'utils/filtering'
import { convertArrayToIdsString, getFormData } from 'utils/formatter'
import { getCurrentSchoolYear } from 'utils/general'

export const createAffiliationFetch = (values) => {
    let formData = getFormData(values)
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/`,
        formData
    )
}

export const createLearningGroupFetch = (data) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}learning_groups/`,
        data
    )
}

export const updateLearningGroupFetch = (data) => {
    return axios.put(`${process.env.REACT_APP_SERVER_PORT}${go}learning_groups/${data.id}/`,
        data
    )
}

export const createGradesAndClassesFetch = (data) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${data.id}/create_grades_and_classes/`, {
        ...data
    })
}


export const editAffiliationFetch = (values) => {
    let formData = getFormData(values)
    return axios.put(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${values.id}/`,
        formData
    )
}

export const getInvalidStudentsFileFetch = async (tClass) => {
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}learning_units/${tClass}/download_invalid_student_file/`, {
        responseType: 'blob'
    })
}

export const getAffiliationsFetch = (filters = {}) => {
    let params = getAssessmentFilters(filters)
    params = {
        ...params, ...setFilters(filters)
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/`, {
        params: params
    })
}

export const getAffiliationsDataFetch = (filters = {}) => {
    const params = setFilters(filters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/get_affiliations_data/`, {
        params: params
    })
}


export const getAffiliationDataFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${id}/get_affiliation_data/`)
}

export const getSchoolStructureFetch = (headerFilters, affiliationId, schoolYear) => {
    const params = getTestTakerFilters(headerFilters)
    delete params.affiliations
    params.affiliation_id = affiliationId
    if (schoolYear) params.school_year = schoolYear?.id || schoolYear

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/get_school_hierarchy/`, {
        params: params
    })
}

export const getLearningGroupStructureFetch = (headerFilters, affiliationId, schoolYear) => {
    let params = getTestTakerFilters(headerFilters)
    delete params.affiliations
    params.affiliation_id = affiliationId
    if (schoolYear) params.school_year = schoolYear?.id || schoolYear

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/get_group_hierarchy/`, {
        params: params
    })
}

export const getSchoolClassesFetch = (id, schoolYear) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${id}/get_school_classes/`, {
        params: {
            school_year: schoolYear || getCurrentSchoolYear()
        }
    })
}

// "צור כיתות ושבץ  " - תצוגה מקדימה (dry_run=true) או ביצוע בפועל (dry_run=false) של קידום
// שכבה/כיתות/תלמידים שנבחרו במסך ניהול לקוחות, משנה ישנה לשנת הלימודים הנוכחית
export const promoteSelectionFetch = (affiliationId, payload) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${affiliationId}/promote_selection/`, payload)
}

export const getLearningGroupFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${id}/get_learning_groups/`, {
        params: {
            school_year: getCurrentSchoolYear()
        }
    })
}

export const getCitiesFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}cities/`)
}

export const getAffiliationDetailsFetch = ({ model, page, pageSize, search, sorting, userFilters }) => {
    const params = setFilters({ model, page, pageSize, sorting, search })
    if (userFilters?.roles?.length > 0)
        params.roles = convertArrayToIdsString(userFilters.roles)
    if (userFilters?.affiliations?.length > 0)
        params.affiliations = convertArrayToIdsString(userFilters.affiliations)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/get_affiliation_details/`, {
        params: params
    })
}

export const getAffiliationFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}affiliations/${id}/`)
}

export const getMethodsFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}methods/`)
}



